import {
  SECTION_ORDER,
  getModulesForKeys,
} from "./rolePermissions";
import { resolveModuleIcon } from "./moduleIcons";

export const drawerWidth = 260;

/**
 * Build sidebar section groups for the given module key list.
 * Sections with no accessible modules are omitted.
 * @param {string[]} moduleKeys
 * @param {object[]} catalog
 * @param {Set<string>|string[]} registeredModuleKeys
 */
export const getSidebarNavGroups = (
  moduleKeys,
  catalog,
  registeredModuleKeys
) => {
  const modules = getModulesForKeys(moduleKeys, catalog, registeredModuleKeys).map(
    (m) => {
      const icons = resolveModuleIcon(m.iconKey);
      return {
        label: m.label,
        to: m.to,
        icon: icons.icon,
        muiIcon: icons.muiIcon,
        alt: icons.alt,
        section: m.section,
      };
    }
  );

  if (!modules.length) return [];

  const sections = [
    ...SECTION_ORDER,
    ...modules.map((m) => m.section).filter((s) => !SECTION_ORDER.includes(s)),
  ];
  const uniqueSections = [...new Set(sections)];

  return uniqueSections
    .map((title) => {
      const items = modules
        .filter((m) => m.section === title)
        .map(({ label, to, icon, muiIcon, alt }) => ({
          label,
          to,
          icon,
          muiIcon,
          alt,
        }));
      return { title, items };
    })
    .filter((group) => group.items.length > 0);
};
